<template>
  <div class="navigation-icon">
    <component :is="iconComponent"/>
  </div>
</template>

<script>
import HomeIcon from './icons/HomeIcon'
import MarketingIcon from './icons/MarketingIcon'
import MerchandiseIcon from './icons/MerchandiseIcon'
// import StockcheckIcon from './icons/StockcheckIcon'
import UsersIcon from './icons/UsersIcon'

export default {
  name: 'NavigationIcon',
  components: {
    HomeIcon,
    MarketingIcon,
    MerchandiseIcon,
    // StockcheckIcon,
    UsersIcon,
  },
  props: {
    name: {
      required: true,
      validator: v => [
        'home',
        'marketing',
        'merchandise',
        'users',
        'stockcheck',
      ].includes(v),
    },
  },
  data() {
    return {
      components: {
        /* eslint-disable quote-props */
        'home': 'HomeIcon',
        'marketing': 'MarketingIcon',
        'merchandise': 'MerchandiseIcon',
        'users': 'UsersIcon',
        /* eslint-enable quote-props */
      },
    }
  },
  computed: {
    iconComponent() {
      return this.components[this.name] || ''
    },
  },
}
</script>

<style lang="scss" scoped>
  .navigation-icon {
    display: inline-block;
    margin-right: 8px;
  }
</style>

<style lang="scss">
.navigation-icon svg {
  margin-bottom: 6px;
}

.el-submenu
.el-submenu__title
.navigation-icon,
.el-menu-item
.navigation-icon {
  svg > g > *, {
    stroke: #8297AA;
  }
  #marketing-icon-triangle {
    fill: #8297AA;
  }
}

// Apply green fill to navigation icon groups
.el-submenu.is-active
.el-submenu__title
.navigation-icon,
.el-menu-item.is-active
.navigation-icon {
  margin-left: -3px;
  svg .override-fill {
    fill: #03C7A4;
  }
  svg .override-stroke {
    stroke: #03C7A4;
  }
  #marketing-icon {
    rect {
      stroke: none;
      fill: #03C7A4;
    }
    path {
      stroke: #ffffff;
      fill: #ffffff;
    }
  }
  #merchandise-icon {
    polygon {
      stroke: none;
    }
    rect {
      stroke: none;
    }
    polyline {
      stroke: #ffffff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/NavigationIcon.vue